import React, { FC } from 'react'

interface ComponentProps {
	shortname: string
	purchasecode: string
}

export const NotificationMessageComponent: FC<ComponentProps> = ({ shortname, purchasecode }) => {
	return (
		<>
			Клиент <b>{shortname}</b>
			<br />
			Закупка <b>{purchasecode}</b>
		</>
	)
}
